import { render, staticRenderFns } from "./fisnumarasidegis.vue?vue&type=template&id=1838f12c&"
import script from "./fisnumarasidegis.vue?vue&type=script&lang=js&"
export * from "./fisnumarasidegis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports